<template>
  <div>
    <server-error :error="error" />
    <div v-if="isLoaded">
      <div v-if="reportTableData != null">
        <button class="b-btn mx-6" @click="exportReportData">
          <dynamic-icon class="b-btn__icon" icon="xls"></dynamic-icon>
          {{$t('CONTENT.reportPage.download_excel')}}
        </button>
        <div class="b-reports__table-wrapper">
          <!--        <div class="b-reports__table-fixed-column">-->
          <!--          <div class="b-reports__table-header-wrap">-->
          <!--            <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">-->
          <!--              {{$t('CONTENT.reportPage.period')}}-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="b-reports__table-row" v-for="item in reportTableDataRows">-->
          <!--            <div-->
          <!--              class="b-full-table__cell b-reports__table-cell"-->
          <!--            >{{getDateInFormattedDate(item.period)}}-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </div>-->
          <div class="b-full-table b-reports__table-wrap mt-4">
            <div class="b-reports__table-header-wrap">
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.period')}}
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                  {{$t('CONTENT.reportPage.lease_obligations')}}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.startLiability')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.events.initialRecognition')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.adjustment')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.percentageLoose')}}
                  </div>
                  <div class="b-reports__table-header-block-wrap">
                    <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                      <button class="b-btn b-btn_type_empty mr-2 b-full-table__icon_hide"
                              @click="isHideLeasePaymentsGroupColumns = !isHideLeasePaymentsGroupColumns">
                        <dynamic-icon icon="circle-minus" v-if="!isHideLeasePaymentsGroupColumns"></dynamic-icon>
                        <dynamic-icon icon="circle-plus" v-if="isHideLeasePaymentsGroupColumns"></dynamic-icon>
                      </button>
                      <span
                        :class="{'b-reports__table-header-subtitle-inner_type_hide': isHideLeasePaymentsGroupColumns}">{{$t('CONTENT.reportPage.lease_payments')}}</span>
                    </div>
                    <div class="b-reports__table-header-block-inner">
                      <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                        {{$t('CONTENT.reportPage.result')}}
                      </div>
                      <div v-if="!isHideLeasePaymentsGroupColumns"
                           class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                        {{$t('CONTENT.reportPage.discount_payment')}}
                      </div>
                      <template
                        v-for="paymentItem in reportTableDataRows[0].liability.leasePaymentsGroup.leasePayments">
                        <div v-if="!isHideLeasePaymentsGroupColumns"
                             class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                          {{paymentItem.name}}
                        </div>
                      </template>
                    </div>
                  </div>
                  <div
                    class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell b-reports__table-cell_bl">
                    {{$t('CONTENT.reportPage.currency_rate_difference')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.endLiability')}}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                  {{$t('CONTENT.reportPage.assets_in_the_form_of_right_of_use')}}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.startLiability')}}
                  </div>
                  <div class="b-reports__table-header-block-wrap">
                    <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                      <button class="b-btn b-btn_type_empty mr-2 b-full-table__icon_hide"
                              @click="isHideInitialRecognitionColumns = !isHideInitialRecognitionColumns">
                        <dynamic-icon icon="circle-minus" v-if="!isHideInitialRecognitionColumns"></dynamic-icon>
                        <dynamic-icon icon="circle-plus" v-if="isHideInitialRecognitionColumns"></dynamic-icon>
                      </button>
                      <span
                        :class="{'b-reports__table-header-subtitle-inner_type_hide': isHideInitialRecognitionColumns}">{{$t('CONTENT.events.initialRecognition')}}</span>
                    </div>
                    <div class="b-reports__table-header-block-inner">
                      <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                        {{$t('CONTENT.reportPage.result')}}
                      </div>
                      <div v-if="!isHideInitialRecognitionColumns"
                           class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                        {{$t('CONTENT.reportPage.liabilities')}}
                      </div>
                      <div v-if="!isHideInitialRecognitionColumns"
                           class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                        {{$t('CONTENT.reportPage.payments_before_start_date')}}
                      </div>
                      <div v-if="!isHideInitialRecognitionColumns"
                           class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                        {{$t('CONTENT.reportPage.first_expenses')}}
                      </div>
                      <div v-if="!isHideInitialRecognitionColumns"
                           class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                        {{$t('CONTENT.reportPage.backlog')}}
                      </div>
                    </div>
                  </div>
                  <div
                    class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell b-reports__table-cell_bl">
                    {{$t('CONTENT.reportPage.adjustment')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.charts.amortization')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.devaluation')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.disposal')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.endLiability')}}
                  </div>
                </div>
              </div>
              <div
                class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell b-reports__table-cell_bl">
                {{$t('CONTENT.reportPage.incomesAndLoose')}}
              </div>
            </div>
            <div class="b-reports__table-content-wrap">
              <div class="b-reports__table-row" v-for="item in reportTableDataRows">
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.period | dateFormatted('short')}}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.liability.startLiability)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.liability.initialRecognition)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.liability.adjustment)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.liability.percentageLoose)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.liability.leasePaymentsGroup.totals)}}
                  </div>
                  <div v-if="!isHideLeasePaymentsGroupColumns"
                       class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.liability.leasePaymentsGroup.discountedTotals)}}
                  </div>
                  <template v-for="paymentItem in item.liability.leasePaymentsGroup.leasePayments">
                    <div v-if="!isHideLeasePaymentsGroupColumns" class="b-full-table__cell b-reports__table-cell">
                      {{convertDecimalToStringForChart(paymentItem.cost)}}
                    </div>
                  </template>
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell b-reports__table-cell_bl"
                >{{convertDecimalToStringForChart(item.liability.currencyRateDifference)}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{convertDecimalToStringForChart(item.liability.endLiability)}}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.assets.startLiability)}}
                  </div>
                  <div class="b-reports__table-block-wrap">
                    <div
                      class="b-full-table__cell b-reports__table-cell"
                    >{{convertDecimalToStringForChart(item.assets.initialRecognition.total)}}
                    </div>
                    <div v-if="!isHideInitialRecognitionColumns"
                         class="b-full-table__cell b-reports__table-cell"
                    >{{convertDecimalToStringForChart(item.assets.initialRecognition.liability)}}
                    </div>
                    <div v-if="!isHideInitialRecognitionColumns"
                         class="b-full-table__cell b-reports__table-cell"
                    >{{convertDecimalToStringForChart(item.assets.initialRecognition.paymentBeforeStartDate)}}
                    </div>
                    <div v-if="!isHideInitialRecognitionColumns"
                         class="b-full-table__cell b-reports__table-cell"
                    >{{convertDecimalToStringForChart(item.assets.initialRecognition.firstExpense)}}
                    </div>
                    <div v-if="!isHideInitialRecognitionColumns"
                         class="b-full-table__cell b-reports__table-cell"
                    >{{convertDecimalToStringForChart(item.assets.initialRecognition.backlog)}}
                    </div>
                  </div>
                </div>


                <div
                  class="b-full-table__cell b-reports__table-cell b-reports__table-cell_bl"
                >{{convertDecimalToStringForChart(item.assets.adjustment)}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{convertDecimalToStringForChart(item.assets.amortization)}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{convertDecimalToStringForChart(item.assets.devaluation)}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{convertDecimalToStringForChart(item.assets.disposal)}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{convertDecimalToStringForChart(item.assets.endLiability)}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell b-reports__table-cell_bl"
                >{{convertDecimalToStringForChart(item.incomesAndLoose)}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsAPI from "../api/ReportsAPI";
import convertDecimalForChart from "@/utils/converters/convert.decimal.for.chart";

export default {
  props: {
    dataForReport: {
      type: Object,
    },
  },
  data() {
    return {
      error: null,
      reportTableData: null,
      reportTableDataRows: null,
      isHideLeasePaymentsGroupColumns: false,
      isHideInitialRecognitionColumns: false,
    };
  },
  async created() {
    await this.formReport(this.dataForReport);
    // this.calcHeightForFixedColumnHeader();
  },
  watch: {
    dataForReport: {
      handler(newVal) {
        this.formReport(newVal);
        // this.calcHeightForFixedColumnHeader();
      },
      deep: true
    },
  },
  methods: {
    async formReport(data) {
      try {
        this.$loadingManager.addLoadingStep();
        this.error = null;
        this.reportTableData = null;
        this.reportTableData = await new ReportsAPI().getReportBasedOnExpenses({
          periodStart: data.periodStart,
          periodEnd: data.periodEnd,
          contractId: data.contractId,
          lesseeId: data.lesseeId
        });
        this.reportTableDataRows = this.reportTableData.rows;
        this.$parent.nonActiveContractIds = this.reportTableData.nonActiveContractIds;
        this.$loadingManager.loadingStepLoaded();
      } catch (e) {
        this.$loadingManager.hideLoadScreen();
        this.error = e;
      }
    },

    convertDecimalToStringForChart(decimal) {
      return convertDecimalForChart(decimal);
    },

    async exportReportData() {
      this.error = null;
      try {
        this.$fileLoadingManager.startLoading()
        const api = new ReportsAPI();
        const response = await api.exportExportResultOfReportBasedOnExpenses(this.reportTableData);

        let filename = null;
        let filenameInURI = null;

        let headerContentDisposition = response.headers['content-disposition'].split(';');
        for (let i = 0; i < headerContentDisposition.length; i++) {
          let item = headerContentDisposition[i].split('=');
          if(item[0].trim() === 'filename*') {
            filenameInURI = item[1].split("''");
            filename = decodeURIComponent(filenameInURI[1]);
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        this.error = e;
        console.error(e);
      }
      this.$fileLoadingManager.finishLoading()
    },

    calcHeightForFixedColumnHeader() {
      let fixedHeader = document.getElementsByClassName('b-reports__table-fixed-column')[0].getElementsByClassName("b-reports__table-header-cell")[0];
      let headerHeight = document.getElementsByClassName('b-reports__table-header-block-wrap_base')[0].offsetHeight;
      fixedHeader.style.height = `${headerHeight}px`;
    }
  }
};
</script>
